export var UITopNotificationType = /*#__PURE__*/ function(UITopNotificationType) {
    UITopNotificationType[UITopNotificationType["Information"] = 0] = "Information";
    UITopNotificationType[UITopNotificationType["Success"] = 1] = "Success";
    UITopNotificationType[UITopNotificationType["Warning"] = 2] = "Warning";
    UITopNotificationType[UITopNotificationType["Error"] = 3] = "Error";
    UITopNotificationType[UITopNotificationType["SocketError"] = 4] = "SocketError";
    UITopNotificationType[UITopNotificationType["Reconnect"] = 5] = "Reconnect";
    return UITopNotificationType;
}({});
export class UINotificationController {
}
